import type OLMap from 'ol/Map';
import type { Coordinate as OLCoordinate } from 'ol/coordinate';
import { toUserCoordinate } from 'ol/proj';

export interface Coordinate {
  longitude: number;
  latitude: number;
  heading?: number | null;
}

// Returns null unless the map has a rendered frame; map.getEventCoordinate throws before then
// (OL transforms a null coordinate in toUserCoordinate when useGeographic is active).
export function getRenderedEventCoordinate(map: OLMap, event: MouseEvent): OLCoordinate | null {
  const internal = map.getCoordinateFromPixelInternal(map.getEventPixel(event)) as OLCoordinate | null;
  if (!internal) return null;

  return toUserCoordinate(internal, map.getView().getProjection());
}
